/* eslint-disable */
import particles from './custom-particles.vue'

const CustomParticles = {

    install (Vue, options) {
        Vue.component('custom-particles', particles)
    }

}

export default CustomParticles
/* eslint-disable */